<template>
  <b-container id="courses_container">
    <b-row>
      <!-- <b-col md="3">
        <div id="side_links">
          <Sidebar></Sidebar>
        </div>
      </b-col> -->
      <b-col md="12">
        <Loading v-if="$store.state.loading || !$store.getters['parcours/list']"></Loading>
        <transition name="fade">
          <div id="featured_content"
            v-if="$store.state.admin.featured_content && $store.state.admin.featured_content.length > 0">
            <FeaturedContent :content="$store.state.admin.featured_content"></FeaturedContent>


          </div>
          <div class="d-flex flex-row  gap-2">
            <a v-for="(extra, index) in $store.state.admin.extra_links" :key="index" :href="extra.url"
              target="_blank"><b-button class="with_icon"><v-icon style="min-width: 17px;margin-right:3px"
                  :name="extra.icon"></v-icon>
                {{ extra.text }}</b-button></a>
          </div>
        </transition>
        <transition name="fade">
          <div id="list_parcours" v-if="list_parcours_live.length > 0">
            <b-row class="equal-height">
              <b-col lg="4" md="6" xs="12" v-for="parcours in list_parcours_live" :key="parcours.id"
                class="col_parcours">
                <ParcoursCard :parcours="parcours"></ParcoursCard>
                <!--  <ParcoursItem :parcours="parcours"></ParcoursItem> -->
              </b-col>
            </b-row>
          </div>
        </transition>
        <transition name="fade">
          <div id="list_parcours" style="margin-top: 20px" v-if="list_parcours_non_classe.length > 0">
            <h2 class="align_left"><b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>{{
              $t("tab_courses.courses_sans_classement") }}</h2>
            <b-row class="equal-height">
              <b-col md="6" v-for="parcours in list_parcours_non_classe" :key="parcours.id" class="col_parcours">
                <ParcoursItem :parcours="parcours"></ParcoursItem>
              </b-col>
            </b-row>
          </div>
        </transition>
        <transition name="fade">
          <div v-if="!$store.state.loading && !$store.getters['parcours/list']">
            <h3>{{ $t("tab_courses.erreur_parcours_manquants") }}</h3>
          </div>
        </transition>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Sidebar from "@/components/Courses_tab/Sidebar.vue";
import Loading from "@/components/Loading.vue";
import ParcoursItem from "@/components/Courses_tab/ParcoursItem.vue";
import ParcoursCard from "@/components/Courses_tab/ParcoursCard.vue";
import FeaturedContent from "@/components/Courses_tab/FeaturedContent.vue";
import axios from "axios";
export default {
  components: { Sidebar, ParcoursItem, Loading, FeaturedContent, ParcoursCard },
  data() {
    return {
      list_parcours_live: [],
      list_parcours_non_classe: [],
    };
  },

  methods: {
    set_parcours_live() {
      var filtered = this.$store.getters['parcours/list'];
      if (!filtered) {
        return;
      }
      filtered = filtered.filter((item) => item.is_live);
      this.list_parcours_live = filtered;
    },
    set_parcours_non_classe() {
      var filtered = this.$store.getters['parcours/list'];
      if (!filtered) {
        return;
      }
      filtered = filtered.filter((item) => !item.is_live);
      this.list_parcours_non_classe = filtered;
    },
  },
  async created() {
    this.$store.commit("setLoading");


    this.set_parcours_live();
    this.set_parcours_non_classe();
    this.$store.commit("unsetLoading");

  },
};
</script>

<style lang="sass" scoped>
</style>